const pathTranslations = {
  '/products/used-automation-equipment': {
    'pt-PT': '/produtos/equipamento-automacao-usado',
    'cs-CZ': '/produkty/pouzite-automatizacni-zarizeni',
    'tr-TR': '/urunler/kullanilmis-otomasyon-ekipmanlari',
    'pl-PL': '/produkty/uzywane-wyposazenie-automatyki',
    'fi-FI': '/tuotteet/kaytetyt-automaatiolaitteet',
    'hu-HU': '/termekek/hasznalt-automatizacios-berendezesek',
    'hr-HR': '/proizvodi/rabljenim-oprema-za-automatizaciju',
    'lv-LV': '/produkti/izmantota-automatizacijas-iekarta',
    'lt-LT': '/produktai/naudota-automatizacijos-iranga',
    'en-GB': '/products/used-automation-equipment',
    'et-EE': '/tooted/kasutatud-automaatikaseadmed',
    'en-IN': '/products/used-automation-equipment',
    'es-MX': '/productos/equipamiento-de-automatizacion-usado',
    'de-AT': '/produkte/gebrauchte-automatisierungsanlagen',
    'en-IE': '/products/used-automation-equipment',
    'nl-NL': '/producten/gebruikte-automatiseringsuitrusting',
    'en-US': '/products/used-automation-equipment',
    'de-DE': '/produkte/gebrauchte-automatisierungsanlagen',
    'it-IT': '/prodotti/attrezzature-di-automazione-usate',
    'ru-RU': '/products/used-automation-equipment',
    'es-ES': '/productos/equipamiento-de-automatizacion-usado',
    'sv-SE': '/produkter/begagnad-automationsutrustning',
    'en-AE': '/products/used-automation-equipment',
    'fr-FR': '/produits/equipements-dautomatisation-doccasion',
  },
  '/products/used-machine-tools': {
    'pt-PT': '/produtos/ferramentas-maquinas-usadas',
    'cs-CZ': '/produkty/pouzite-stroje-nastroje',
    'tr-TR': '/urunler/kullanilmis-makine-aletleri',
    'pl-PL': '/produkty/uzywane-obrabiarki',
    'fi-FI': '/tuotteet/kaytetyt-koneet-tyokalut',
    'hu-HU': '/termekek/hasznalt-szerszamgepek',
    'hr-HR': '/proizvodi/rabljeni-alatni-strojevi',
    'lv-LV': '/produkti/lietoti-darbagaldi',
    'lt-LT': '/produktai/naudoti-masinu-irankiai',
    'en-GB': '/products/used-machine-tools',
    'et-EE': '/tooted/kasutatud-toopingid',
    'en-IN': '/products/used-machine-tools',
    'es-MX': '/productos/maquinas-herramienta-usadas',
    'de-AT': '/produkte/gebrauchte-werkzeugmaschinen',
    'en-IE': '/products/used-machine-tools',
    'nl-NL': '/producten/gebruikte-werktuigmachines',
    'en-US': '/products/used-machine-tools',
    'de-DE': '/produkte/gebrauchte-werkzeugmaschinen',
    'it-IT': '/prodotti/macchine-utensili-usati',
    'ru-RU': '/products/used-machine-tools',
    'es-ES': '/productos/maquinas-herramienta-usadas',
    'sv-SE': '/produkter/begagnade-verktygsmaskiner',
    'en-AE': '/products/used-machine-tools',
    'fr-FR': '/produits/machines-outils-doccasion',
  },
  '/products/used-plastics-processing-machinery': {
    'pt-PT': '/produtos/maquinaria-processamento-plasticos-usados',
    'cs-CZ': '/produkty/pouzite-stroje-na-zpracovani-plastu',
    'tr-TR': '/urunler/kullanilmis-plastik-isleme-makineleri',
    'pl-PL': '/produkty/uzywane-maszyny-do-obrobki-tworzyw-sztucznych',
    'fi-FI': '/tuotteet/kaytetyt-muovinjalostuskoneet',
    'hu-HU': '/termekek/hasznalt-muanyagfeldolgozo-gep',
    'hr-HR': '/proizvodi/rabljeni-strojevi-za-obradu-plastike',
    'lv-LV': '/produkti/lietotas-plastmasas-apstrades-masinas',
    'lt-LT': '/produktai/naudotos-plastiko-apdorojimo-masinos',
    'en-GB': '/products/used-plastics-processing-machinery',
    'et-EE': '/tooted/kasutatud-plastitootlusseade',
    'en-IN': '/products/used-plastics-processing-machinery',
    'es-MX': '/productos/maquinaria-de-procesamiento-de-plasticos-usada',
    'de-AT': '/produkte/gebrauchte-kunststoffverarbeitungsmaschinen',
    'en-IE': '/products/used-plastics-processing-machinery',
    'nl-NL': '/producten/gebruikte-kunststofverwerkingsmachines',
    'en-US': '/products/used-plastics-processing-machinery',
    'de-DE': '/produkte/gebrauchte-kunststoffverarbeitungsmaschinen',
    'it-IT': '/prodotti/macchine-per-la-lavorazione-della-plastica-usati',
    'ru-RU': '/products/plastics-processing-machinery',
    'es-ES': '/productos/maquinaria-de-procesamiento-de-plasticos-usada',
    'sv-SE': '/produkter/begagnade-plast-bearbetningsmaskiner',
    'en-AE': '/products/used-plastics-processing-machinery',
    'fr-FR': '/produits/machines-doccasion-pour-la-transformation-du-plastique',
  },
  '/products/used-sheet-metal-machinery': {
    'pt-PT': '/produtos/maquinaria-chapas-metal-usada',
    'cs-CZ': '/produkty/pouzite-stroje-plechove-stroje',
    'tr-TR': '/urunler/kullanilmis-sac-makine',
    'pl-PL': '/produkty/uzywane-maszyny-do-obrobki-blach',
    'fi-FI': '/tuotteet/kaytetyt-levytyokoneet',
    'hu-HU': '/termekek/hasznalt-lemezsajtolo-gepek',
    'hr-HR': '/proizvodi/rabljeni-strojevi-za-obradu-lima',
    'lv-LV': '/produkti/lietotas-loksnu-metala-masinas',
    'lt-LT': '/produktai/naudotos-lakstu-masinos',
    'en-GB': '/products/used-sheet-metal-machinery',
    'et-EE': '/tooted/kasutatud-lehtmetalliseadmed',
    'en-IN': '/products/used-sheet-metal-machinery',
    'es-MX': '/productos/maquinas-para-chapa-usadas',
    'de-AT': '/produkte/gebrauchte-blechbearbeitungsmaschinen',
    'en-IE': '/products/used-sheet-metal-machinery',
    'nl-NL': '/producten/gebruikte-plaatbewerkingsmachines',
    'en-US': '/products/used-sheet-metal-machinery',
    'de-DE': '/produkte/gebrauchte-blechbearbeitungsmaschinen',
    'it-IT': '/prodotti/macchine-per-la-lavorazione-della-lamiera-usate',
    'ru-RU': '/products/used-sheet-metal-machinery',
    'es-ES': '/productos/maquinas-para-chapa-usadas',
    'sv-SE': '/produkter/begagnade-platbearbetningsmaskiner',
    'en-AE': '/products/used-sheet-metal-machinery',
    'fr-FR': '/produits/machines-doccasion-pour-la-tolerie',
  },
  '/products/used-wood-working-machinery': {
    'pt-PT': '/produtos/maquinaria-de-trabalho-em-madeira-usada',
    'cs-CZ': '/produkty/pouzite-drevoobrabeci-stroje',
    'tr-TR': '/urunler/kullanilmis-ahsap-isleme-makineleri',
    'pl-PL': '/produkty/uzywane-maszyny-do-obrobki-drewna',
    'fi-FI': '/tuotteet/kaytetyt-puunjalostuskoneet',
    'hu-HU': '/termekek/hasznalt-faipari-gepek',
    'hr-HR': '/proizvodi/rabljeni-strojevi-za-obradu-drva',
    'lv-LV': '/produkti/lietotas-kokapstrades-iekartas',
    'lt-LT': '/produktai/naudotos-medzio-apdirbimo-masinos',
    'en-GB': '/products/used-wood-working-machinery',
    'en-IN': '/products/used-wood-working-machinery',
    'en-IE': '/products/used-wood-working-machinery',
    'en-US': '/products/used-wood-working-machinery',
    'en-AE': '/products/used-wood-working-machinery',
    'et-EE': '/tooted/kasutatud-puidutootlemismasinad',
    'nl-NL': '/producten/gebruikte-houtbewerkingsmachines',
    'de-AT': '/produkte/gebrauchte-holzbearbeitungsmaschinen',
    'de-DE': '/produkte/gebrauchte-holzbearbeitungsmaschinen',
    'it-IT': '/prodotti/macchine-per-la-lavorazione-del-legno-usate',
    'ru-RU':
      '/products/деревообрабатывающее-оборудование-бывшее-в-употреблении',
    'es-ES': '/productos/maquinaria-usada-para-trabajar-la-madera',
    'es-MX': '/productos/maquinaria-usada-para-trabajar-la-madera',
    'sv-SE': '/produkter/begagnade-trabearbetningsmaskiner',
    'fr-FR': '/produits/machines-doccasion-pour-le-travail-du-bois',
  },
  '/products': {
    'pt-PT': '/produtos',
    'cs-CZ': '/produkty',
    'tr-TR': '/urunler',
    'pl-PL': '/produkty',
    'fi-FI': '/tuotteet',
    'hu-HU': '/termekek',
    'hr-HR': '/proizvodi',
    'lv-LV': '/produkti',
    'lt-LT': '/produktai',
    'en-GB': '/products',
    'et-EE': '/tooted',
    'en-IN': '/products',
    'es-MX': '/productos',
    'de-AT': '/produkte',
    'en-IE': '/products',
    'nl-NL': '/producten',
    'en-US': '/products',
    'de-DE': '/produkte',
    'it-IT': '/prodotti',
    'ru-RU': '/products',
    'es-ES': '/productos',
    'sv-SE': '/produkter',
    'en-AE': '/products',
    'fr-FR': '/produits',
  },
  '/product/[machine_id]': {
    'pt-PT': '/produto/[machine_id]',
    'cs-CZ': '/produkt/[machine_id]',
    'tr-TR': '/urun/[machine_id]',
    'pl-PL': '/produkt/[machine_id]',
    'fi-FI': '/tuote/[machine_id]',
    'hu-HU': '/termek/[machine_id]',
    'hr-HR': '/proizvod/[machine_id]',
    'lv-LV': '/produkts/[machine_id]',
    'lt-LT': '/produktas/[machine_id]',
    'en-GB': '/product/[machine_id]',
    'et-EE': '/toode/[machine_id]',
    'en-IN': '/product/[machine_id]',
    'es-MX': '/producto/[machine_id]',
    'de-AT': '/produkt/[machine_id]',
    'en-IE': '/product/[machine_id]',
    'nl-NL': '/product/[machine_id]',
    'en-US': '/product/[machine_id]',
    'de-DE': '/produkt/[machine_id]',
    'it-IT': '/prodotto/[machine_id]',
    'ru-RU': '/product/[machine_id]',
    'es-ES': '/producto/[machine_id]',
    'sv-SE': '/produkt/[machine_id]',
    'en-AE': '/product/[machine_id]',
    'fr-FR': '/produit/[machine_id]',
  },
  '/selling-process/step-1': {
    'pt-PT': '/processo-venda/passo-1',
    'cs-CZ': '/prodejni-proces/krok-1',
    'tr-TR': '/satis-surec/asama-1',
    'pl-PL': '/sprzedaz/krok-1',
    'fi-FI': '/myyntiprosessi/vaihe-1',
    'hu-HU': '/eladasi-folyamat/1.-lepes',
    'hr-HR': '/postupak-prodaje/prvi-korak',
    'lv-LV': '/pardosanas-process/1-darbiba',
    'lt-LT': '/pardavimo-procesas/1-veiksmas',
    'en-GB': '/selling-process/step-1',
    'et-EE': '/muugiprotsess/1. etapp',
    'en-IN': '/selling-process/step-1',
    'es-MX': '/venta/paso-1',
    'de-AT': '/verkaufsprozess/schritt-1',
    'en-IE': '/selling-process/step-1',
    'nl-NL': '/verkoopproces/stap-1',
    'en-US': '/selling-process/step-1',
    'de-DE': '/verkaufsprozess/schritt-1',
    'it-IT': '/processo-di-vendita/passo-1',
    'ru-RU': '/selling-process/step-1',
    'es-ES': '/venta/paso-1',
    'sv-SE': '/forsaljningsprocess/steg-1',
    'en-AE': '/selling-process/step-1',
  },
  '/selling-process/step-2': {
    'pt-PT': '/processo-venda/passo-2',
    'cs-CZ': '/prodejni-proces/krok-2',
    'tr-TR': '/satis-surec/asama-2',
    'pl-PL': '/sprzedaz/krok-2',
    'fi-FI': '/myyntiprosessi/vaihe-2',
    'hu-HU': '/eladasi-folyamat/2.-lepes',
    'hr-HR': '/postupak-prodaje/drugi-korak',
    'lv-LV': '/pardosanas-process/2-darbiba',
    'lt-LT': '/pardavimo-procesas/2-veiksmas',
    'en-GB': '/selling-process/step-2',
    'et-EE': '/muugiprotsess/2. etapp',
    'en-IN': '/selling-process/step-2',
    'es-MX': '/venta/paso-2',
    'de-AT': '/verkaufsprozess/schritt-2',
    'en-IE': '/selling-process/step-2',
    'nl-NL': '/verkoopproces/stap-2',
    'en-US': '/selling-process/step-2',
    'de-DE': '/verkaufsprozess/schritt-2',
    'it-IT': '/processo-di-vendita/passo-2',
    'ru-RU': '/selling-process/step-2',
    'es-ES': '/venta/paso-2',
    'sv-SE': '/forsaljningsprocess/steg-2',
    'en-AE': '/selling-process/step-2',
  },
  '/selling-process/step-3': {
    'pt-PT': '/processo-venda/passo-3',
    'cs-CZ': '/prodejni-proces/krok-3',
    'tr-TR': '/satis-surec/asama-3',
    'pl-PL': '/sprzedaz/krok-3',
    'fi-FI': '/myyntiprosessi/vaihe-3',
    'hu-HU': '/eladasi-folyamat/3.-lepes',
    'hr-HR': '/postupak-prodaje/tre%C4%87i-korak',
    'lv-LV': '/pardosanas-process/3-darbiba',
    'lt-LT': '/pardavimo-procesas/3-veiksmas',
    'en-GB': '/selling-process/step-3',
    'et-EE': '/muugiprotsess/3. etapp',
    'en-IN': '/selling-process/step-3',
    'es-MX': '/venta/paso-3',
    'de-AT': '/verkaufsprozess/schritt-3',
    'en-IE': '/selling-process/step-3',
    'nl-NL': '/verkoopproces/stap-3',
    'en-US': '/selling-process/step-3',
    'de-DE': '/verkaufsprozess/schritt-3',
    'it-IT': '/processo-di-vendita/passo-3',
    'ru-RU': '/selling-process/step-3',
    'es-ES': '/venta/paso-3',
    'sv-SE': '/forsaljningsprocess/steg-3',
    'en-AE': '/selling-process/step-3',
  },
  '/selling-process/step-4': {
    'pt-PT': '/processo-venda/passo-4',
    'cs-CZ': '/prodejni-proces/krok-4',
    'tr-TR': '/satis-surec/asama-4',
    'pl-PL': '/sprzedaz/krok-4',
    'fi-FI': '/myyntiprosessi/vaihe-4',
    'hu-HU': '/eladasi-folyamat/4.-lepes',
    'hr-HR': '/postupak-prodaje/%C4%8Detvrti-korak',
    'lv-LV': '/pardosanas-process/4. darbiba',
    'lt-LT': '/pardavimo-procesas/4-veiksmas',
    'en-GB': '/selling-process/step-4',
    'et-EE': '/muugiprotsess/4. etapp',
    'en-IN': '/selling-process/step-4',
    'es-MX': '/venta/paso-4',
    'de-AT': '/verkaufsprozess/schritt-4',
    'en-IE': '/selling-process/step-4',
    'nl-NL': '/verkoopproces/stap-4',
    'en-US': '/selling-process/step-4',
    'de-DE': '/verkaufsprozess/schritt-4',
    'it-IT': '/processo-di-vendita/passo-4',
    'ru-RU': '/selling-process/step-4',
    'es-ES': '/venta/paso-4',
    'sv-SE': '/forsaljningsprocess/steg-4',
    'en-AE': '/selling-process/step-4',
  },
  '/selling-process': {
    'pt-PT': '/processo-venda',
    'cs-CZ': '/prodejni-proces',
    'tr-TR': '/satis-surec',
    'pl-PL': '/sprzedaz',
    'fi-FI': '/myyntiprosessi',
    'hu-HU': '/eladasi-folyamat',
    'hr-HR': '/postupak-prodaje',
    'lv-LV': '/pardosanas-process',
    'lt-LT': '/pardavimo-procesas',
    'en-GB': '/selling-process',
    'et-EE': '/muugiprotsess',
    'en-IN': '/selling-process',
    'es-MX': '/venta',
    'de-AT': '/verkaufsprozess',
    'en-IE': '/selling-process',
    'nl-NL': '/verkoopproces',
    'en-US': '/selling-process',
    'de-DE': '/verkaufsprozess',
    'it-IT': '/processo-di-vendita',
    'ru-RU': '/selling-process',
    'es-ES': '/venta',
    'sv-SE': '/forsaljningsprocess',
    'en-AE': '/selling-process',
    'fr-FR': '/processus-de-vente',
  },
  '/careers': {
    'de-DE': '/karriere',
    'es-ES': '/empleos',
    'fr-FR': '/carri%C3%A8res',
    'cs-CZ': '/kariery',
    'pt-PT': '/ofertas-de-emprego',
    'tr-TR': '/kariyer',
    'pl-PL': '/praca',
    'fi-FI': '/tyopaikat',
    'hu-HU': '/allaslehetosegek',
    'hr-HR': '/posao',
    'lv-LV': '/darba-iespejas',
    'lt-LT': '/karjera',
    'en-GB': '/careers',
    'et-EE': '/karjaar',
    'en-IN': '/careers',
    'es-MX': '/empleos',
    'de-AT': '/karriere',
    'en-IE': '/careers',
    'nl-NL': '/vacatures',
    'en-US': '/careers',
    'it-IT': '/lavora-con-noi',
    'ru-RU': '/careers',
    'sv-SE': '/jobb',
    'en-AE': '/careers',
  },
  '/cookie-policy': {
    'pt-PT': '/politica-cookies',
    'cs-CZ': '/cookie-policy',
    'tr-TR': '/cerez-politikasi',
    'pl-PL': '/polityke-plikow-cookie',
    'fi-FI': '/evastekaytanto',
    'hu-HU': '/s%C3%BCtik',
    'hr-HR': '/politika-kolacica',
    'lv-LV': '/sikfailu-politika',
    'lt-LT': '/slapuku-politikos-nuostatos',
    'en-GB': '/cookie-policy',
    'et-EE': '/kupsisepoliitika',
    'en-IN': '/cookie-policy',
    'es-MX': '/politica-de-coookies',
    'de-AT': '/cookie-richtlinie',
    'en-IE': '/cookie-policy',
    'nl-NL': '/cookiebeleid',
    'en-US': '/cookie-policy',
    'de-DE': '/cookie-richtlinie',
    'it-IT': '/politica-sui-cookie',
    'ru-RU': '/cookie-policy',
    'es-ES': '/politica-de-coookies',
    'sv-SE': '/cookie-policy',
    'en-AE': '/cookie-policy',
    'fr-FR': '/donnees-personnelles-et-cookies',
  },
  '/financing-options': {
    'pt-PT': '/opcoes-financiamento',
    'cs-CZ': '/moznosti-financovani',
    'tr-TR': '/finansman-secenekleri',
    'pl-PL': '/opcje-finansowania',
    'fi-FI': '/rahoitus-vaihtoehdot',
    'hu-HU': '/finanszirozas-lehetosegek',
    'hr-HR': '/opcije-placanja',
    'lv-LV': '/apmaksas-iespejas',
    'lt-LT': '/finansavimo-galimybes',
    'en-GB': '/financing-options',
    'et-EE': '/finantseerimisvoimalused',
    'en-IN': '/financing-options',
    'es-MX': '/financiacion',
    'de-AT': '/finanzierungsoptionen',
    'en-IE': '/financing-options',
    'nl-NL': '/financieringsopties',
    'en-US': '/financing-options',
    'de-DE': '/finanzierungsoptionen',
    'it-IT': '/opzioni-finanziamento',
    'ru-RU': '/financing-options',
    'es-ES': '/financiacion',
    'sv-SE': '/finansieringsalternativ',
    'en-AE': '/financing-options',
    'fr-FR': '/options-de-financement',
  },
  '/general-terms-and-conditions-of-purchase': {
    'pt-PT': '/termos-e-condicoes-da-compra',
    'cs-CZ': '/vseobecne-podminky-nakupu',
    'tr-TR': '/genel-sartlar-ve-satinalma-kosulları',
    'pl-PL': '/ogolne-zasady-i-warunki-zakupu',
    'fi-FI': '/yleiset-ostoehdot',
    'hu-HU': '/altalanos-szerzodesi-feltetelek-es-vasarlasi-feltetelek',
    'hr-HR': '/op%C4%87i-uvjeti-kupnje',
    'lv-LV': '/visparigi-pirkuma-noteikumi-un nosacijumi',
    'lt-LT': '/bendrosios-pirkimo-salygos',
    'en-GB': '/general-terms-and-conditions-of-purchase',
    'et-EE': '/uldtingimused-ja-ostutingimused',
    'en-IN': '/general-terms-and-conditions-of-purchase',
    'es-MX': '/terminos-y-condiciones-generales-de-compra',
    'de-AT': '/allgemeine-einkaufsbedingungen',
    'en-IE': '/general-terms-and-conditions-of-purchase',
    'nl-NL': '/algemene-aankoopvoorwaarden',
    'en-US': '/general-terms-and-conditions-of-purchase',
    'de-DE': '/allgemeine-einkaufsbedingungen',
    'it-IT': '/termini-e-condizioni-generali-di-acquisto',
    'ru-RU': '/general-terms-and-conditions-of-purchase',
    'es-ES': '/terminos-y-condiciones-generales-de-compra',
    'sv-SE': '/allmanna-kopvillkor',
    'en-AE': '/general-terms-and-conditions-of-purchase',
  },
  '/general-terms-and-conditions-of-sale': {
    'en-GB': '/general-terms-and-conditions-of-sale',
    'en-IN': '/general-terms-and-conditions-of-sale',
    'en-US': '/general-terms-and-conditions-of-sale',
    'en-AE': '/general-terms-and-conditions-of-sale',
    'en-IE': '/general-terms-and-conditions-of-sale',
    'ru-RU': '/general-terms-and-conditions-of-sale',
    'de-AT': '/allgemeine-verkaufsbedingungen',
    'de-DE': '/allgemeine-verkaufsbedingungen',
    'es-MX': '/terminos-y-condiciones-generales-de-venta',
    'es-ES': '/terminos-y-condiciones-generales-de-venta',
    'pt-PT': '/condicoes-gerais-de-venda',
    'cs-CZ': '/vseobecne-podminky-prodeje',
    'tr-TR': '/genel-sartlar-ve-satis-kosullari',
    'pl-PL': '/ogolne-zasady-i-warunki-sprzedazy',
    'fi-FI': '/yleiset-myyntiehdot',
    'hu-HU': '/altalanos-eladasi-feltetelek-es-kikotesek',
    'hr-HR': '/opci-uvjeti-prodaje',
    'lv-LV': '/visparigi-pardosanas-noteikumi-un-nosacijumi',
    'lt-LT': '/bendrosios-pardavimo-salygos-ir-terminai',
    'et-EE': '/uldtingimused-ja-muugitingimused',
    'nl-NL': '/algemene-verkoopvoorwaarden',
    'it-IT': '/termini-e-condizioni-generali-di-vendita',
    'sv-SE': '/allmanna-villkor-och-forsaljningsvillkor',
  },
  '/legal': {
    'pt-PT': '/legal',
    'cs-CZ': '/pravni',
    'tr-TR': '/yasal',
    'pl-PL': '/nota-prawna',
    'fi-FI': '/oikeudellinen huomautus',
    'hu-HU': '/jogi',
    'hr-HR': '/pravna',
    'lv-LV': '/juridiska informacija',
    'lt-LT': '/teisine informacija',
    'en-GB': '/legal',
    'et-EE': '/juriidiline teave',
    'en-IN': '/legal',
    'es-MX': '/aviso-legal',
    'de-AT': '/impressum',
    'en-IE': '/legal',
    'nl-NL': '/wettelijk',
    'en-US': '/legal',
    'de-DE': '/impressum',
    'it-IT': '/avviso-legale',
    'ru-RU': '/legal',
    'es-ES': '/aviso-legal',
    'sv-SE': '/juridisk-information',
    'en-AE': '/legal',
    'fr-FR': '/mentions%20l%C3%A9gales',
  },
  '/logistic-services': {
    'pt-PT': '/servicos-logisticos',
    'cs-CZ': '/logistickych-sluzeb',
    'tr-TR': '/lojistik-hizmetleri',
    'pl-PL': '/uslugi-logistyczne',
    'fi-FI': '/logistiikka-palvelut',
    'hu-HU': '/logisztika-szolgaltatasok',
    'hr-HR': '/logisticke-usluge',
    'lv-LV': '/logistikas-pakalpojumi',
    'lt-LT': '/logistikos-paslaugos',
    'en-GB': '/logistics-services',
    'et-EE': '/logistikateenused',
    'en-IN': '/logistics-services',
    'es-MX': '/servicios-logistica',
    'de-AT': '/logistik-services',
    'en-IE': '/logistics-services',
    'nl-NL': '/logistieke-diensten',
    'en-US': '/logistics-services',
    'de-DE': '/logistik-services',
    'it-IT': '/servizi-logistici',
    'ru-RU': '/logistics-services',
    'es-ES': '/servicios-logistica',
    'sv-SE': '/logistikservice',
    'en-AE': '/logistics-services',
    'fr-FR': '/services-logistiques',
  },
  '/machine-categories': {
    'pt-PT': '/categorias-maquinas',
    'cs-CZ': '/strojni-kategorie',
    'tr-TR': '/makine-kategoriler',
    'pl-PL': '/kategorie-maszyn',
    'fi-FI': '/kone-kategoriat',
    'hu-HU': '/gepkategoriak',
    'hr-HR': '/kategorije-strojeva',
    'lv-LV': '/masinu-kategorijas',
    'lt-LT': '/masinos-kategorijos',
    'en-GB': '/machine-categories',
    'et-EE': '/seadmete-kategooriad',
    'en-IN': '/machine-categories',
    'es-MX': '/categorias-maquinas',
    'de-AT': '/maschinenkategorien',
    'en-IE': '/machine-categories',
    'nl-NL': '/machine-categorie%C3%ABn',
    'en-US': '/machine-categories',
    'de-DE': '/maschinenkategorien',
    'it-IT': '/categorie-macchine',
    'ru-RU': '/machine-categories',
    'es-ES': '/categorias-maquinas',
    'sv-SE': '/maskinkategorier',
    'en-AE': '/machine-categories',
    'fr-FR': '/categories-de-machines',
  },
  '/newsletter-unsubscribe': {
    'pt-PT': '/newsletter-unsubscribe',
    'cs-CZ': '/newsletter-unsubscribe',
    'tr-TR': '/newsletter-unsubscribe',
    'pl-PL': '/newsletter-unsubscribe',
    'fi-FI': '/newsletter-unsubscribe',
    'hu-HU': '/newsletter-unsubscribe',
    'hr-HR': '/newsletter-unsubscribe',
    'lv-LV': '/newsletter-unsubscribe',
    'lt-LT': '/newsletter-unsubscribe',
    'en-GB': '/newsletter-unsubscribe',
    'et-EE': '/newsletter-unsubscribe',
    'en-IN': '/newsletter-unsubscribe',
    'es-MX': '/newsletter-unsubscribe',
    'de-AT': '/newsletter-unsubscribe',
    'en-IE': '/newsletter-unsubscribe',
    'nl-NL': '/newsletter-unsubscribe',
    'en-US': '/newsletter-unsubscribe',
    'de-DE': '/newsletter-unsubscribe',
    'it-IT': '/newsletter-unsubscribe',
    'ru-RU': '/newsletter-unsubscribe',
    'es-ES': '/newsletter-unsubscribe',
    'sv-SE': '/newsletter-unsubscribe',
    'en-AE': '/newsletter-unsubscribe',
    'fr-FR': '/newsletter-unsubscribes',
  },
  '/premium-inspection': {
    'pt-PT': '/inspecao-premium',
    'cs-CZ': '/premiova-kontrola',
    'tr-TR': '/prim-muayene',
    'pl-PL': '/inspekcja-premium',
    'fi-FI': '/premium-tarkastus',
    'hu-HU': '/premium-vizsgalat',
    'hr-HR': '/premium-inspekcija',
    'lv-LV': '/augstakas-kvalitates-parbaude',
    'lt-LT': '/auksciausios-klases-patikra',
    'en-GB': '/premium-inspection',
    'et-EE': '/esmaklassiline-ulevaatus',
    'en-IN': '/premium-inspection',
    'es-MX': '/inspeccion-premium',
    'de-AT': '/premium-inspektion',
    'en-IE': '/premium-inspection',
    'nl-NL': '/premium-inspectie',
    'en-US': '/premium-inspection',
    'de-DE': '/premium-inspektion',
    'it-IT': '/ispezione-premium',
    'ru-RU': '/premium-inspection',
    'es-ES': '/inspeccion-premium',
    'sv-SE': '/premiuminspektion',
    'en-AE': '/premium-inspection',
    'fr-FR': '/inspection-prime',
  },
  '/privacy': {
    'pt-PT': '/privacidade',
    'cs-CZ': '/soukromi',
    'tr-TR': '/gizlilik',
    'pl-PL': '/prywatno%C5%9B%C4%87',
    'fi-FI': '/tietosuoja',
    'hu-HU': '/adatvedelem',
    'hr-HR': '/privatnost',
    'lv-LV': '/prywatno%C5%9B%C4%87',
    'lt-LT': '/privatumas',
    'en-GB': '/privacy',
    'et-EE': '/privaatsus',
    'en-IN': '/privacy',
    'es-MX': '/privacidad',
    'de-AT': '/Datenschutz',
    'en-IE': '/privacy',
    'nl-NL': '/privacy',
    'en-US': '/privacy',
    'de-DE': '/Datenschutz',
    'it-IT': '/privacy',
    'ru-RU': '/privacy',
    'es-ES': '/privacidad',
    'sv-SE': '/integritet',
    'en-AE': '/privacy',
    'fr-FR': '/confidentialite',
  },
  '/we-buy-your-project': {
    'pt-PT': '/compramos-seu-projeto',
    'cs-CZ': '/koup%C3%ADme-vas-projekt',
    'tr-TR': '/projenizi-satin-aliyoruz',
    'pl-PL': '/kupujemy-twoj-projekt',
    'fi-FI': '/ostamme-projektisi',
    'hu-HU': '/megvasaroljuk-a-projektjet',
    'hr-HR': '/kupujemo-vas-projekt',
    'lv-LV': '/mes-perkam-jusu-projektu',
    'lt-LT': '/mes-perkame-jusu-projekta',
    'en-GB': '/we-buy-your-project',
    'et-EE': '/me-ostame-teie-projekti',
    'en-IN': '/we-buy-your-project',
    'es-MX': '/compramos-su-proyecto',
    'de-AT': '/wir-kaufen-ihr-projekt',
    'en-IE': '/we-buy-your-project',
    'nl-NL': '/wij-kopen-uw-project',
    'en-US': '/we-buy-your-project',
    'de-DE': '/wir-kaufen-ihr-projekt',
    'it-IT': '/compriamo-il-tuo-progetto',
    'ru-RU': '/we-buy-your-project',
    'es-ES': '/compramos-su-proyecto',
    'sv-SE': '/vi-koper-ditt-projekt',
    'en-AE': '/we-buy-your-project',
    'fr-FR': '/nous-achetons-votre-projet',
  },
  '/who-we-are': {
    'pt-PT': '/quem-somos',
    'cs-CZ': '/kdo-jsme',
    'tr-TR': '/biz-kimiz',
    'pl-PL': '/o-nas',
    'fi-FI': '/tietoja-meista',
    'hu-HU': '/kik-vagyunk',
    'hr-HR': '/tko-smo-mi',
    'lv-LV': '/par-mums',
    'lt-LT': '/kas-mes-esame',
    'en-GB': '/who-we-are',
    'et-EE': '/kes-me-oleme',
    'en-IN': '/who-we-are',
    'es-MX': '/quienes-somos',
    'de-AT': '/ueber-uns',
    'en-IE': '/who-we-are',
    'nl-NL': '/wie-zijn-wij',
    'en-US': '/who-we-are',
    'de-DE': '/ueber-uns',
    'it-IT': '/chi-siamo',
    'ru-RU': '/who-we-are',
    'es-ES': '/quienes-somos',
    'sv-SE': '/vilka-vi-ar',
    'en-AE': '/who-we-are',
    'fr-FR': '/qui-nous-sommes',
  },
};

exports.pathTranslations = pathTranslations;
